import { SelectOption } from 'modules/queryBuilder/contexts';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { SUBSCRIBED_MESSAGE_TYPES } from 'utils/fieldConstants';
import { MESSAGE_TYPE_SUBSCRIPTION_FEATURE_FLAG } from '../../../featureFlags';

export const useFilterMessageTypeSubscriptionsFromOptions = () => {
  const isFeatureFlagged = useFeatureFlag(MESSAGE_TYPE_SUBSCRIPTION_FEATURE_FLAG);
  return (options: SelectOption<string>[]) =>
    options.filter((option) =>
      isFeatureFlagged ? option : option.value !== SUBSCRIBED_MESSAGE_TYPES,
    );
};
